// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { toollist } from './tool-list';

const { Button } = toollist;

/**
 * @class Jsw.CustomButton
 * @extends Jsw.toollist.Button
 */
export const CustomButton = Class.create(Button, {
    /**
     * @param {String} path
     * @returns {String}
     */
    getImagePath(path) {
        return path;
    },
});

Object.extend(Form.Element.Methods, {
    disable(element) {
        element = $(element);
        element.disabled = 'disabled';
        element.addClassName('disabled');
        return element;
    },

    enable(element) {
        element = $(element);
        element.disabled = false;
        element.removeClassName('disabled');
        return element;
    },
});

Element.addMethods();



// WEBPACK FOOTER //
// ./jsw/custom-button.js